import React from "react";

const SearchTags = ({ title, tags }) => {
    if (tags.length === 0) {
        return null;
    }

    return (
        <div className="search__tags">
            <div className="search__title">{title}</div>
            <div className="search__tags__list">
                {tags.map((tag) => {
                    return (
                        <a key={tag.id} href={tag.link}>
                            #{tag.name}
                        </a>
                    );
                })}
            </div>
        </div>
    );
};

export default SearchTags;
